/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungsschluesselDto } from '../../models/buchungsschluessel-dto';

export interface GetAllBuchungsschluessel$Plain$Params {
}

export function getAllBuchungsschluessel$Plain(http: HttpClient, rootUrl: string, params?: GetAllBuchungsschluessel$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungsschluesselDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllBuchungsschluessel$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BuchungsschluesselDto>>;
    })
  );
}

getAllBuchungsschluessel$Plain.PATH = '/v1/buchungsschluessel';
